import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { ForceUpdate as ForceUpdateService, openAppStore } from '@egw/force-update'
import { Button } from '@egw/components'
import { sendEvent } from '@egw/events'

export const ForceUpdate: FC = () => {
  const { t } = useTranslation('features-system')

  return (
    <ForceUpdateService>
      <div className="fixed top-0 left-0 right-0 bottom-0 bg-white egw-container flex flex-col items-center justify-center z-20 text-center">
        <h1 className="typo-primary-4xl-light mb-xl">{t('force_update.title')}</h1>
        <p className="typo-primary-base-regular mb-sm">{t('force_update.description_p1')}</p>
        <p className="typo-primary-base-regular mb-xl">{t('force_update.description_p2')}</p>
        <Button
          testId="force-update-button"
          onClick={() => {
            sendEvent('user_force_update_click')
            void openAppStore()
          }}
        >
          {t('force_update.update')}
        </Button>
      </div>
    </ForceUpdateService>
  )
}
